class TenderTypeReportController extends BaseController
	@register angular.module 'App.Module.Controller'
	@inject '$scope',
		'$stateParams'
		'$state'
		'TenderTypeSalesRepository'

	initialize: ->
		@filter =
			start_date: moment().startOf('month').unix()
			end_date: moment().endOf('month').unix()
			shop_id: null

		@datePicker =
			enableClear: true

		@searching = false

		@search()

	search: ->
		@searching = true

		tenderTypesQuery = @TenderTypeSalesRepository.getQuery()
			.addParameter 'shop_id', @filter.shop_id
			.addParameter 'starttime', @filter.start_date
			.addParameter 'endtime', @filter.end_date

		@TenderTypeSalesRepository
			.findByQuery tenderTypesQuery
			.then (response) =>
				@tendertypes = response.data
			.finally =>
				@searching = false

	showOrders: (tenderTypeId) ->
		queryParams =
			shop_id: @filter.shop_id
			tender_type_id: tenderTypeId
			start_date: @filter.start_date
			end_date: @filter.end_date

		@$state.go('reports.orders', queryParams)
